import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf, faSprayCan, faBoxes, faChartLine,faHistory } from "@fortawesome/free-solid-svg-icons";

export const MainMenu = () => {
  const menuItems = [
    {
      title: "Nutrition",
      icon: faLeaf,
      description: "Gérer la nutrition des cultures et les plans de fertilisation",
      path: "/fertigation",
      color: "success",
    },
    {
      title: "Traitements",
      icon: faSprayCan,
      description: "Suivre et planifier les applications de produits",
      path: "/sprays",
      color: "info"
    },

    {
      title: "Inventaire",
      icon: faBoxes,
      description: "Gérer l'inventaire et les fournitures agricoles",
      path: "/products/inventory",
      color: "warning"
    },
    {
      title: "Mouvements de l'inventaire",
      icon: faHistory,
      description: "Afficher l'historique des transactions de l'inventaire",
      path: "/products/inventory/transactions",
      color: "warning"
    },
    {
      title: "Supervision",
      icon: faChartLine,
      description: "Surveiller la santé et la progression des cultures",
      path: "/monitoring/fruit-size",
      color: "primary"
    }
  ];

  return (
    <div className="container-fluid p-4" >
      <Row>
        {menuItems.map((item, index) => (
          <Col key={index} xs={12} sm={6} lg={3} className="mb-4">
            <Link to={item.path} className="text-decoration-none">
              <Card className="h-100 hover-shadow">
                <CardBody className="text-center">
                  <FontAwesomeIcon 
                    icon={item.icon} 
                    size="3x" 
                    className={`mb-3 text-${item.color}`}
                  />
                  <h4 className="card-title mb-3">{item.title}</h4>
                  <p className="card-text text-muted">
                    {item.description}
                  </p>
                </CardBody>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
};